<div class="form-check form-switch" *ngIf="estado == true">
  <!-- checked -->
  <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked" (click)="clickEnable.emit(id)" checked>
</div>

<div class="form-check form-switch" *ngIf="estado == false">
  <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked" (click)="clickEnable.emit(id)">
</div>

<!-- <label class="switch switch_type1" role="switch" *ngIf="estado == true">
  <input type="checkbox" class="switch__toggle" (click)="clickEnable.emit(id)" checked="false" />
  <span class="switch__label"></span>
</label>
<label class="switch switch_type1" role="switch" *ngIf="estado == false">
  <input type="checkbox" class="switch__toggle" (click)="clickEnable.emit(id)" />
  <span class="switch__label"></span>
</label> -->
